import React from 'react';
import OOSAlert from '@nykaa/cart-shared/wrapper/OOSAlert';
import { useDispatch, useSelector } from 'react-redux';
import { deviceTypes, ORIGIN_SOURCE } from '@nykaa/cart-shared/constants';
import { CartEvents } from '@nykaa/cart-shared/constants/tracking';
import { getAnalyticsData } from '@nykaa/cart-shared/helpers/tracking';
import { setCartInfo, setToastMessage } from '@nykaa/cart-shared/store/action';
import { EDD_EXPERIEMENT_HEADER } from '@nykaa/cart-shared/store/constants';
import { pushData } from '@nykaa/data-layer';
import {
  addToWishlist,
  removeProductFromBag,
} from '@nykaa/cart-shared/store/service';
import { setItemQuantityInStorage } from '../Products';
import { pages } from 'constants/urls';
import { useIsLoggedIn } from 'hooks/auth';
import { State } from 'store/types';

interface Props {
  showBottomSheet: boolean;
  toggleShowOOSBottomSheet: () => void;
  isConvenienceFeeEnabled?: boolean;
}

const OOSAlertWidget = ({
  showBottomSheet,
  toggleShowOOSBottomSheet,
  isConvenienceFeeEnabled,
}: Props) => {
  const dispatch = useDispatch();
  const isLoggedIn = useIsLoggedIn();
  const { items, pincode } = useSelector(
    (state: State) => state.cartReducer.cartInfo
  );
  const cartEddWidget =
    useSelector((state: State) => state.remoteConfig.switches.cartEddWidget) ||
    false;
  const oosGenericMessage = useSelector(
    (state: State) =>
      state?.remoteConfig?.configs?.cartGenericMessages?.oosMessages
  ) || { status: false, messages: {} };

  const authHandler = () => {
    window.location.href = pages.AUTH_PAGE;
  };

  const removeHandler = async (ids: string[]) => {
    const params = {
      deviceType: deviceTypes.DESKTOP,
      productIds: ids,
      originSource: ORIGIN_SOURCE.CART,
      pincode,
      headers: { [EDD_EXPERIEMENT_HEADER]: cartEddWidget },
      domain: __PLATFORM__,
      catalog_tag_filter: __PLATFORM__,
    };
    try {
      const data = await removeProductFromBag(params, isConvenienceFeeEnabled);
      const payload = getAnalyticsData(CartEvents.CART_ITEM_REMOVE, {
        cartInfo: data,
      });
      const removeFromCartPayload = getAnalyticsData(
        CartEvents.REMOVE_FROM_CART_GTM,
        {
          cartInfo: data,
        }
      );
      pushData(payload.gtmData);
      pushData(removeFromCartPayload.gtmData);
      setItemQuantityInStorage(data?.quantity);
      setCartInfo(data)(dispatch);
    } catch (err) {
      setToastMessage('Something went wrong!')(dispatch);
    }
  };

  const wishlistHandler = async (ids: string[]) => {
    const params = {
      deviceType: deviceTypes.DESKTOP,
      host: ORIGIN_SOURCE.CART,
      items: ids,
      originSource: ORIGIN_SOURCE.CART,
      headers: { [EDD_EXPERIEMENT_HEADER]: cartEddWidget },
      domain: __PLATFORM__,
      catalog_tag_filter: __PLATFORM__,
    };
    try {
      const data = await addToWishlist(params);
      const payload = getAnalyticsData(CartEvents.CART_ITEM_ADD_TO_WISHLIST, {
        cartInfo: data,
      });
      pushData(payload.gtmData);
      removeHandler(ids);
    } catch (err) {
      setToastMessage('Something went wrong!')(dispatch);
    }
  };

  return (
    <OOSAlert
      items={items}
      isGuest={!isLoggedIn}
      oosMessages={oosGenericMessage}
      showBottomSheet={showBottomSheet}
      toggleBottomSheet={toggleShowOOSBottomSheet}
      authHandler={authHandler}
      wishlistHandler={wishlistHandler}
      removeHandler={removeHandler}
      deviceType={deviceTypes.DESKTOP}
    />
  );
};

export default OOSAlertWidget;
